export default "__VITE_ASSET__aos4gceB__"